export default "__VITE_ASSET__abe1448d__"